<template>
  <div>
    <div class="katta">
      <span>{{ $t("Ходим") }}</span>
      <button
        style="padding: 4px 10px; margin-right: 10px"
        class="btn"
        @click="Prev()"
      >
        <b-icon style="color: white" icon="house-door-fill"> </b-icon>
      </button>
    </div>
    <div class="oyna1">
      <div class="ustun">
        <div>
          <span>
            {{ $t("Ф.И.Ш") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null">
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.user_name.required"
                >{{ $t("Ф.И.Ш тўлдирилиши керак") }}</span
              >
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.user_name.minLength"
                >{{ $t("Ф.И.Ш да камида 4 та белги бўлиши керак") }}</span
              >
            </span>
          </span>
          <b-input v-model="modelvue.user_name" type="text" />
        </div>

        <div>
          <span>
            {{ $t("Хона") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null">
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.room_id.required"
                >{{ $t("Хона тўлдирилиши керак") }}</span
              >
            </span>
          </span>
          <v-select
            :options="xonalar"
            label="name"
            :reduce="option => option.id"
            v-model="modelvue.room_id"
          />
        </div>
        <div>
          <span>
            {{ $t("Тўлов тури") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null">
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.pay_type.required"
                >{{ $t("Тўлов тури тўлдирилиши керак") }}</span
              >
            </span>
          </span>
          <v-select
            :options="tolovTuri"
            label="name"
            v-model="modelvue.pay_type"
          />
        </div>
        <div v-if="modelvue.pay_type == 'Oylik'">
          <span>{{ $t("Иш ҳаққи") }}</span>
          <vue-numeric
            style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
            v-model="modelvue.salary"
            separator="space"
            :precision="2"
          ></vue-numeric>
        </div>
        <div v-if="modelvue.pay_type == 'Foiz'">
          <span>{{ $t("Иш ҳаққи") }}</span>
          <vue-numeric
            style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
            v-model="modelvue.percent"
            separator="space"
          ></vue-numeric>
        </div>
        <div style="display: flex; justify-content: space-between; width: 500px;">
          <div>
            <span>{{ "Келди деб ҳисоблансин" }}</span> <br>
            <input type="time" v-model="modelvue.come_time_start">
          </div>
          <div>
            <span>{{ "Келиш вақти" }}</span> <br>
            <input type="time" v-model="modelvue.come_time">
          </div>
          <div>
            <span>{{ "Келди деб ҳисоблансин" }}</span> <br>
            <input type="time" v-model="modelvue.come_time_end">
          </div>
        </div>
        <div style="display: flex; justify-content: space-between; width: 500px;">
          <div>
            <span>{{ "Кетди деб ҳисоблансин" }}</span> <br>
            <input type="time" v-model="modelvue.leave_time_start">
          </div>
          <div>
            <span>{{ "Кетиш вақти" }}</span> <br>
            <input type="time" v-model="modelvue.leave_time">
          </div>
          <div>
            <span>{{ "Кетди деб ҳисоблансин" }}</span> <br>
            <input type="time" v-model="modelvue.leave_time_end">
          </div>

        </div>
        <div>
          <span>
            <span class="shirift">{{ $t("Фаолияти") }}</span>
          </span>
          <v-select
            :options="condition"
            label="name"
            :components="{ Deselect }"
            :reduce="option => option.key"
            v-model="modelvue.condition"
          />
        </div>
        <div>
          <div class="card" v-if="modelvue.image">
            <img style="width: 240px; height: 245px;" :src="`${BASE_URL}images/${modelvue.image}`" alt="Hodim rasmi" />
          </div>
          <input 
            class="form-control form-control-lg" 
            id="formFileLg" 
            type="file" 
            accept="image/*"
            @change="onFileSelected"
          >
        </div>
      </div>

      <div class="ustun">
        <div>
          <span>
            {{ $t("Парол") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null">
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.password.required"
                >{{ $t("Парол тўлдирилиши керак") }}</span
              >
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.password.minLength"
                >{{ $t("Паролда камида 6 та белги бўлиши керак") }}</span
              >
            </span>
          </span>
          <b-input v-model="modelvue.password" type="password" />
        </div>

        <div>
          <span>
            {{ $t("Ҳуқуқи") }}
            <span style="color: red;">*</span>
            <span v-if="errors !== null">
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.role.required"
                >{{ $t("Ҳуқуқи тўлдирилиши керак") }}</span
              >
              <span
                style="color: red; font-size: 9px"
                v-if="!errors.role.minLength"
                >{{ $t("Ҳуқуқида камида 4 та белги бўлиши керак") }}</span
              >
            </span>
          </span>
          <v-select :options="category" label="name" v-model="modelvue.role" />
        </div>

        <div v-if="modelvue.role == 'Shifokor'">
          <span>{{ $t("Шифокор") }}</span>
          <v-select
            :options="Shifokor"
            label="name"
            v-model="modelvue.doctor_id"
            :reduce="doctor => doctor.id"
          />
        </div>

        <div v-if="modelvue.role == 'Loborant' || modelvue.role == 'Uzi '">
          <span>{{ $t("Текширув бўлимлари") }}</span>
          <v-select
            :options="tekshiruvBolimlari"
            label="name"
            v-model="modelvue.inspection_category_id"
            :reduce="inspection => inspection.id"
          />
        </div>
        <div v-if="modelvue.role == 'Shifokor'">
          <span>{{ $t("Палата фоиз") }}</span>
          <vue-numeric
            style="width: 100%; height: 35px; border: 1px solid #bdb2b2; border-radius: 3px;"
            v-model="modelvue.palata_percent"
            separator="space"
          ></vue-numeric>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["BASE_URL"],
  name: "edit-profile-form",
  props: ["modelvue", "errors"],
  data() {
    return {
      hodimlar: [],
      Shifokor: [],
      tekshiruvBolimlari: [],
      condition: [
        { key: "inaction", name: "Фаолийатда" },
        { key: "notinaction", name: "Фаолийатда эмас" }
      ],
      Deselect: {
        render: createElement => createElement("span", "")
      },
      xonalar: [],
      category: [
        "Registrator",
        "Shifokor",
        "Loborant",
        "Admin",
        "Kasser",
        "Katta hamshira",
        "Hamshira",
        "Baholovchi"
      ],
      tolovTuri: ["Foiz", "Oylik"]
    };
  },
  methods: {
    onFileSelected(event) {
      this.modelvue.image = null;
      const file = event.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      try {
        axios.post('/user/upload', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(response => {
          this.modelvue.image = response.data.data;
          console.log('Upload success:', response.data);
        });
      } catch (error) {
        console.error('Upload error:', error);
      }      
    },
    home() {
      this.modelvue = {
        user_name: "",
        pay_type: "",
        room_id: "",
        salary: "",
        password: "",
        role: "",
        doctor_id: ""
      };
    },
    getXonalar() {
      let self = this;
      axios({
        method: "get",
        url: "/room/all"
      }).then(res => {
        self.xonalar = res.data.data;
      });
    },
    getInspection_category() {
      let self = this;
      axios({
        method: "get",
        url: "/inspector_category/all"
      }).then(res => {
        self.tekshiruvBolimlari = res.data.data;
      });
    },
    Prev() {
      this.$router.push("/hodimlar");
    },
    getDoctor() {
      let self = this;
      axios({
        method: "get",
        url: "/doctor/all"
      }).then(res => {
        self.Shifokor = res.data;
      });
    }
  },
  mounted() {
    this.getXonalar();
    this.getInspection_category();
    this.getDoctor();
  }
};
</script>
<style>
.katta {
  background: #007bff;
  margin-top: -25px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 700;
  line-height: 40px;
  border-radius: 8px;
  color: #fff;
  text-indent: 15px;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.5);
}
.oyna1 {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}
.shirift {
  font-size: 16px;
}
.ustun {
  width: 49%;
}
.card{
  margin-top: 10px;
  border: 1px solid #ccc;
  width: 250px;
  height: 250px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 5px 8px 10px rgba(25, 95, 176, 0.5);
}
#formFileLg{
  width: 350px;
  margin-top: 10px;
}
</style>
